import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Panel, Slider, Text } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

export const DisplaySliderItem = ({
  register,
  tc,
  icon,
  min,
  max,
  step,
  onFormat,
  onChange,
  sliderValueConvert,
  disabled,
  borderOff,
}) => {
  const [value, setValue] = useState(register.value);
  const formatValue = (value) => {
    if (onFormat !== undefined) {
      return onFormat(value, '');
    } else {
      return value;
    }
  };

  const convertSliderValue = (value) => {
    if (sliderValueConvert !== undefined) {
      return sliderValueConvert(value);
    } else {
      return value;
    }
  };

  const updateValue = (value, event) => {
    devLog('update Value', event, value);
    onChange(register, value);
  };

  useEffect(() => {
    setValue(register.value);
  }, [register.value]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <div className="truncate space-y-1 w-1/2">
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
          <Text color={tc} className="truncate">
            <Bold>{register.display}</Bold>
          </Text>
        </div>
        <div
          style={{
            display: 'block',
            width: '100%',
            paddingLeft: 10,
            paddingRight: 5,
          }}
        >
          <Slider
            progress
            barClassName="slideritem"
            min={min}
            max={max}
            step={step}
            value={convertSliderValue(value)}
            onChange={setValue}
            onChangeCommitted={updateValue}
            renderTooltip={formatValue}
            disabled={disabled}
          />
        </div>
      </Flex>
    </Panel>
  );
};
